var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes},[_c('c-icon',_vm._b({},'c-icon',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }